import { createSlice } from "@reduxjs/toolkit";

export const defaultSurveyCategory = createSlice({
  name: "defaultSurveyCategory",
  initialState: {
    value: "",
    label: "",
  },
  reducers: {
    setDefaultSurveyCategory: (state, action) => {
      state.value = action?.payload?.value;
      state.label = action?.payload?.label;
    },
  },
});

export const { setDefaultSurveyCategory } = defaultSurveyCategory.actions;

export default defaultSurveyCategory.reducer;
